import "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/styles/base.css"
import "/workspaces/ft-docs/node_modules/@vuepress/plugin-prismjs/lib/client/styles/nord.css"
import "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/styles/line-numbers.css"
import "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/styles/notation-highlight.css"
import "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/styles/collapsed-lines.css"
import { setupCollapsedLines } from "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/index.js"
import "/workspaces/ft-docs/node_modules/@vuepress/highlighter-helper/lib/client/styles/code-block-title.css"

export default {
  setup() {
    setupCollapsedLines()
  }
}
